<style lang="scss" scoped>
.check-green {
  color: $green;
}
.times-red {
  color: $red;
}
</style>

<template>
  <td class="text-center text-lg">
    <i v-if="content" class="fas fa-check check-green"></i>
    <i v-else class="fas fa-times times-red"></i>
  </td>
</template>

<script lang="babel">
export default {
  props: {
    content: {
      required: true,
    }
  }
};
</script>
